import React, { Component } from "react";
import { txtBox } from "../utils/Forms";
import { Link } from "react-router-dom";
import _ from "lodash";

export default class AdminPasswordForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {},
      errors: {},
      loading: true
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  setFormData(admin = {}) {
    const formData = {
      id: admin.id
    };

    this.setState({ formData, loading: false });
  }

  componentWillReceiveProps(nextProps) {
    this.setFormData(nextProps.admin);
  }

  handleChange(event) {
    const target = event.target;
    const name = target.name;
    const value = target.value;
    const updatedFormData = { ...this.state.formData, [name]: value };
    this.setState({ ...this.state, formData: updatedFormData });
  }

  isFormValid(formData) {
    let errors = {};
    const { password, password_confirmation } = formData;

    if (_.isEmpty(password)) {
      errors["password"] = "Password is required";
    } else if (password !== password_confirmation) {
      errors["password"] = "Passwords don't match";
      errors["password_confirmation"] = "Passwords don't match";
    }

    this.setState({ errors });
    return _.isEmpty(errors);
  }

  handleSubmit(event) {
    if (this.isFormValid(this.state.formData)) {
      this.props.saveAdmin(this.state.formData, "password");
    }
    event.preventDefault();
  }

  render() {
    const { password, password_confirmation } = this.state.formData;
    const { errors, loading } = this.state;
    const loadingView = (
      <div style={{ textAlign: "center" }}> Loading... please wait </div>
    );
    const form = (
      <div className="row">
        <form onSubmit={this.handleSubmit}>
          <div className="clearfix col-md-offset-3">
            {txtBox("Password", "password", password, this, {
              errors,
              type: "password"
            })}
            {txtBox(
              "Confirm Password",
              "password_confirmation",
              password_confirmation,
              this,
              {
                errors,
                type: "password"
              }
            )}
          </div>
          <div className="row">
            <div
              style={{ textAlign: "center" }}
              className="col-md-12 edit-buttons-pane"
            >
              <Link
                to="/admins"
                className="btn btn-default"
                style={{ marginRight: 10 }}
              >
                {" "}Cancel{" "}
              </Link>
              <input
                className="btn btn-success "
                type="submit"
                value="Update password"
              />
            </div>
          </div>
        </form>
      </div>
    );

    const view = loading ? loadingView : form;
    return (
      <div>
        {view}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AdminPasswordForm.js